import type { CdlAltDealStructurePrediction } from '@makemydeal/dr-dash-store/types/cdl';
import { LEASE, RequestType, type AltDealStructureGridCell } from '@makemydeal/dr-platform-types';
import type { Slot } from './PaymentStructureGrid/types';

/** Map the lowercase OfferType (finance/lease) to the capitalized CDL deal type (Finance/Lease). */
export const toCdlDealType = (dealType: AltDealStructureGridCell['dealType']): RequestType =>
    dealType === LEASE ? RequestType.LEASE : RequestType.FINANCE;

/** Map a ready grid cell to the `deal.predictions.dealStructure` payload (Part 2). */
export const buildDealStructurePredictionPayload = (cell: AltDealStructureGridCell): CdlAltDealStructurePrediction => ({
    dealType: toCdlDealType(cell.dealType),
    term: cell.term,
    downPayment: cell.downPayment,
    profitTotal: cell.profitTotal,
    monthlyPayment: cell.monthlyPayment,
    affordabilityLikelihood: cell.affordabilityIndex,
    lenderId: cell.lenderId,
    lenderName: cell.lender
});

/**
 * Build the `deal.predictions.dealStructure` array from the presented (ready) grid slots.
 * Pass `dealType` to scope to a single grid (dc-mv-289/292); omit for all presented (dc-mv-291/296).
 */
export const buildDealStructurePredictionsFromSlots = (
    slots: Slot[],
    dealType?: Slot['dealType']
): CdlAltDealStructurePrediction[] =>
    slots
        .filter((slot) => slot.status === 'ready' && slot.data && (!dealType || slot.dealType === dealType))
        .map((slot) => buildDealStructurePredictionPayload(slot.data!));
